import React, { useState } from "react";
import { View } from "react-native";
import { connect } from "react-redux";
import { addAddress, updateAddress } from "../actions/user";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import CustomButton from "./CustomButton";
import CustomInput from "./CustomInput";

function AddressForm({
  addAddress,
  updateAddress,
  index,
  onSubmit = () => {},
  initialValues = {
    name: "",
    address: "",
    pincode: "",
    phone: "",
    city: "",
    state: "",
  },
}) {
  const [name, setName] = useState(initialValues.name);
  const [address, setAddress] = useState(initialValues.address);
  const [pin, setPin] = useState("" + initialValues.pincode);
  const [phone, setPhone] = useState(initialValues.phone);
  const [city, setCity] = useState(initialValues.city);
  const [state, setState] = useState(initialValues.state);
  const [required, setRequired] = useState(false);

  const inputs = [
    {
      label: "Full name",
      placeholder: "Your Full name",
      value: name,
      onChangeText: (value) => setName(value),
    },
    {
      label: "Address",
      placeholder: "Your Address",
      value: address,
      onChangeText: (value) => setAddress(value),
      required: true,
      error: required && !address,
      requiredText: "House No. /street /landmark",
    },
    {
      label: "Pin Code",
      placeholder: "Area Pin Code",
      value: pin,
      required: true,
      error: required && (!pin || `${pin}`.length !== 6),
      requiredText: "eg: 560083",
      onChangeText: (value) => {
        if (`${value}`.length <= 6) {
          setPin(value);
        }
      },
      keyboardType: "numeric",
    },
    {
      label: "Mobile Number",
      placeholder: "Your Mobile Number",
      value: phone,
      required: true,
      error: required && !phone,
      requiredText: "phone number for delevary contact",
      onChangeText: (value) => setPhone(value),
      keyboardType: "numeric",
    },
    {
      label: "City",
      placeholder: "Your City",
      value: city,
      required: true,
      error: required && !city,
      requiredText: "eg: Bangalore",
      onChangeText: (value) => setCity(value),
    },
    {
      label: "State",
      placeholder: "Your State",
      value: state,
      error: required && !state,
      required: true,
      requiredText: "eg: Karnataka",
      onChangeText: (value) => setState(value),
    },
  ];

  const handleSubmit = () => {
    if (address && pin && phone && city && state) {
      let addressInfo = {
        address,
        name,
        pincode: pin,
        city,
        state,
        phone,
      };
      if (index !== undefined) {
        fetchApi({
          path: `/users/me/addresses/${initialValues._id}`,
          method: "PUT",
          body: addressInfo,
        }).then((res) => {
          if (!res.error) {
            updateAddress({ index: index, data: res });
            onSubmit();
          }
        });
      } else {
        fetchApi({
          path: "/users/me/addresses",
          method: "POST",
          body: addressInfo,
        }).then((res) => {
          if (!res.error) {
            addAddress(res);
            onSubmit();
          }
        });
      }
    } else {
      setRequired(true);
    }
  };

  return (
    <View>
      {inputs.map(
        ({ placeholder, value, label, onChangeText, ...item }, index) => (
          <CustomInput
            key={index + "id"}
            placeholder={placeholder}
            containerStyle={{ marginVertical: 5 }}
            label={label}
            value={value}
            color="#000000"
            onChangeText={(value) => {
              setRequired(false);
              onChangeText(value);
            }}
            {...item}
          />
        )
      )}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CustomButton
          text="Cancel"
          onPress={onSubmit}
          textStyle={{
            fontSize: STYLES.fontSizes.medium,
            color: STYLES.colors.blueGrey,
          }}
        />
        <CustomButton
          text="Submit"
          btnStyle={{
            backgroundColor: "#000000",
          }}
          onPress={handleSubmit}
          textStyle={{ color: "#ffffff", fontSize: STYLES.fontSizes.medium }}
        />
      </View>
    </View>
  );
}

const mapStateToProps = (state) => ({
  addresses: state.user.addresses,
});

const mapDispatchToProps = (dispatch) => ({
  addAddress: (data) => dispatch(addAddress(data)),
  updateAddress: (data) => dispatch(updateAddress(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressForm);
